<template>
  <div class="box flex">
    <!-- 课次列表部分开始 -->
    <div class="classTimesList">
      <!-- 输入课次搜索框 -->
      <div style="padding: 20px 30px; box-sizing: border-box">
        <div class="courseSearch-box flex align spaceBetween">
          <input class="courseSearch" type="text" placeholder="输入课次名称" />
          <img class="searchIcon" src="../../assets/resourceManagement/searchIcon.png" />
        </div>
      </div>
      <!-- 课次列表标题 -->
      <div class="classTimesList-title-box flex align">
        <div style="width: 12px; height: 26px; background: #3096fb"></div>
        <div class="classTimesList-title">课次列表</div>
      </div>
      <!-- 全部课次 -->
      <div @click="allClasses" :class="currentClassesIdx == -1 ? 'allClasses' : 'classList'">
        <div class="classList-circle"></div>
        <div class="classList-num">全部课次</div>
      </div>
      <!-- 课次列表 -->
      <div class="classList-box">
        <!-- 课次列表 -->
        <div @click="singleClass(index)" :class="currentClassesIdx == index ? 'allClasses' : 'classList'"
          v-for="(item, index) in allListClasses" :key="index">
          <div class="classList-circle"></div>
          <div class="classList-num">课次{{ index + 1 }}</div>
          <div class="classList-name">{{ item.name }}</div>
        </div>
      </div>
    </div>
    <!-- 课次列表部分结束 -->
    <!-- 资源库 习题库 作业库部分 -->
    <div class="resourcesContent">
      <div class="inputSearch-box">
        <input class="inputSearch" type="text" placeholder="输入资源名称" />
        <img class="searchIcon" src="../../assets/resourceManagement/searchIcon.png" />
      </div>
      <div>
        <el-table :data="resourceList" @selection-change="changeFun" :row-style="{ height: '30px' }" fit
          height="calc(100vh - 1.3rem)" style="width: 100%">
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column show-overflow-tooltip align="center" prop="content" label="题干"> </el-table-column>
          <el-table-column show-overflow-tooltip align="center" prop="types" label="类型"> </el-table-column>
          <el-table-column show-overflow-tooltip align="center" prop="created" label="上传时间"> </el-table-column>
          <el-table-column show-overflow-tooltip align="center" prop="classLevel" label="所属课次"> </el-table-column>
          <el-table-column show-overflow-tooltip align="center" prop="usage" label="位置"> </el-table-column>
          <el-table-column show-overflow-tooltip align="center" prop="score" label="分值"> </el-table-column>
        </el-table>
        <!-- 资源列表部分结束 -->
        <!-- 按钮 -->
        <div class="flex justify">
          <div @click="btnUpload" class="pushButton pointer">上传</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { resourceList } from "@/api";
export default {
  data() {
    return {
      currentClassesIdx: -1, // 当前选中的课次
      allListClasses: [], // 全部课次列表
      resourceList: [], // 资源列表
      multipleSelection: [], // 选中的题目数组
      storedData: [], // 储存的数据
      comeFrom: "", // 路由参数
    };
  },
  created() {
    this.comeFrom = this.$route.params.comeFrom; // 获取路由参数
    this.storedData = this.$store.state.questionBankData; // 获取储存的数据
    // console.log(this.storedData);
    // 获取当前课程全部课次的数据
    this.allListClasses = this.$store.state.classListRecord;
    // console.log(this.allListClasses);
    // 资源列表接口调取数据
    let params = { lesson_id: this.$store.state.courseDetails.id, lesson_item_id: 0, types: "examitem", page: 1, num: 30, is_items: "true" };
    this.publicClassResources(params);
  },
  methods: {
    //复选框状态改变
    changeFun(val) {
      this.multipleSelection = val;
      // console.log(this.multipleSelection);
    },
    // 获取资源列表数据公共方法
    publicClassResources(params) {
      resourceList(params).then((res) => {
        this.resourceList = [];
        for (let i in res.data.datas) {
          if (res.data.datas[i].exam_item) {
            this.resourceList.push(res.data.datas[i].exam_item);
          }
        }
        this.$store.commit("GET_ResourceListRecord", res.data.datas); // 提交资源列表到store
        for (let i in this.resourceList) {
          let publicRes = this.resourceList[i];
          publicRes.created = publicRes.created.substring(0, 10);
          publicRes.score = publicRes.score + "分";
          this.resourceList[i].content = this.resourceList[i].content.replace(/<[^>]+>/g, "");
          // 所属课次
          publicRes.classLevel = "";
          for (let j = 0; j < publicRes.lesson_items.length; j++) {
            for (let i = 0; i < this.allListClasses.length; i++) {
              // console.log(publicRes.lesson_items[j].name);
              if (this.allListClasses[i].name == publicRes.lesson_items[j].name) {
                publicRes.classLevel += "          课次" + (i + 1) + "." + publicRes.lesson_items[j].name;
              }
            }
          }
          // 类型
          if (publicRes.types == "single") {
            publicRes.types = "单选题";
          } else if (publicRes.types == "multi") {
            publicRes.types = "多选题";
          } else if (publicRes.types == "truefalse") {
            publicRes.types = "判断题";
          } else if (publicRes.types == "answer") {
            publicRes.types = "简答题";
          } else if (publicRes.types == "blank") {
            publicRes.types = "填空题";
          }
          // 位置
          if (publicRes.usage == "front") {
            publicRes.usage = "课前";
          } else if (publicRes.usage == "middle") {
            publicRes.usage = "课中";
          } else if (publicRes.usage == "back") {
            publicRes.usage = "课后";
          }
        }
      });
    },
    // 选中全部课次的逻辑
    allClasses() {
      this.currentClassesIdx = -1;
      // 资源列表接口调取数据
      let params = { lesson_id: this.$store.state.courseDetails.id, lesson_item_id: 0, types: "examitem", page: 1, num: 30, is_items: "true" };
      this.publicClassResources(params);
      this.$store.commit("GET_ClassTimesId", 0); // 提交当前课程选中课次到store
    },
    // 选中单个课次的逻辑
    singleClass(idx) {
      this.currentClassesIdx = idx;
      // 资源列表接口调取数据
      let classTimesNum = this.allListClasses[idx].id;
      this.$store.commit("GET_ClassTimesId", classTimesNum); // 提交当前课程选中课次到store
      let params = {
        lesson_id: this.$store.state.courseDetails.id,
        lesson_item_id: this.$store.state.classTimesId,
        types: "examitem",
        page: 1,
        num: 1000,
        is_items: "true",
      };
      this.publicClassResources(params);
    },
    // 上传
    btnUpload() {
      let storedData = this.storedData.concat(this.multipleSelection);
      this.$store.commit("GET_questionBankData", storedData); // 储存题目列表到store
      if (this.comeFrom == "testPaperComposition") {
        this.$router.push({ name: "manualTestComposition", params: { method: "handMovement", record: this.$route.params.record } });
      } else {
        this.$router.push({ name: "addTestPaper", params: { method: "handMovement", record: this.$route.params.record } });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.pointer {
  cursor: pointer;
}

::-webkit-scrollbar {
  /*隐藏滚轮*/
  display: none;
}

.flex {
  display: flex;
}

.column {
  flex-direction: column;
}

.align {
  align-items: center;
}

.justify {
  justify-content: center;
}

.spaceBetween {
  justify-content: space-between;
}

.box {
  width: 100%;
  height: 100%;
  background: #ffffff;
  box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.11);
  border-radius: 10px;
}

// 课次列表部分
.classTimesList {
  display: flex;
  flex-direction: column;
  width: 466px;
  height: 100%;
  border-right: 1px solid #bfbfbf;
}

.courseSearch-box {
  width: 406px;
  height: 45px;
  border: 1px solid #dddddd;
  border-radius: 23px;
  padding: 0 27px;
  box-sizing: border-box;
}

.courseSearch {
  width: 300px;
  font-size: 18px;

  font-weight: 400;
  color: #999999;
  background-color: transparent;
  border: 0px;
  outline: none;
}

.classTimesList-title-box {
  margin-bottom: 2px;
  background: rgba(52, 154, 254, 0.25);
  padding: 17px 20px;
  box-sizing: border-box;
}

.classTimesList-title {
  margin-left: 20px;
  font-size: 24px;

  font-weight: 400;
  color: #000000;
  line-height: 24px;
}

.classList-box {
  flex: 1;
  overflow: scroll;
}

.allClasses {
  background: #eaeaea;
  padding: 16px 31px;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.classList-circle {
  width: 10px;
  height: 10px;
  background: #3096fb;
  border-radius: 50%;
}

.classList-num {
  margin-left: 22px;
  font-size: 18px;

  font-weight: 400;
  color: #000000;
  line-height: 18px;
}

.classList-name {
  margin-left: 10px;
  font-size: 18px;

  font-weight: 400;
  color: #000000;
  line-height: 18px;
}

// 课次列表
.classList {
  padding: 16px 31px;
  background: #ffffff;
  display: flex;
  align-items: center;
  cursor: pointer;
}

.classList:hover {
  background: #eaeaea;
}

// 资源库 习题库 作业库部分
.resourcesList {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.libraryListTop {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 1273px;
  height: 85px;
  border-bottom: 1px solid #bfbfbf;
}

.libraryList-box {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 248px;
  height: 40px;
  cursor: pointer;
}

.resourcesContent {
  width: 100%;
  height: 100%;
  padding: 20px 30px;
  box-sizing: border-box;
}

.inputSearch-box {
  width: 406px;
  height: 45px;
  border: 1px solid #dddddd;
  border-radius: 23px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 27px;
}

.inputSearch {
  width: 300px;
  font-size: 18px;

  font-weight: 400;
  color: #999999;
  background-color: transparent;
  border: 0px;
  outline: none;
}

/* 自定义placeholder的默认样式 */
input::-webkit-input-placeholder {
  color: #666666;
}

.resourceFunction {
  width: 100%;
  height: 51px;
  padding: 0 20px;
  box-sizing: border-box;
  border-bottom: 1px solid #bfbfbf;
}

.arrangeBy-txt {
  font-size: 18px;
  font-weight: 400;
  color: #000000;
}

.gaugeOutfit {
  width: 100%;
  padding: 0 20px;
  height: 51px;
  box-sizing: border-box;
  border-bottom: 1px solid #bfbfbf;
}

.gaugeOutfit-txt {
  font-size: 18px;

  font-weight: 400;
  color: #666666;
}

// 资源列表
.resourceList {
  width: 100%;
  height: 51px;
  padding: 0 20px;
  box-sizing: border-box;
  border-bottom: 1px solid #bfbfbf;
}

.resourceList-name {
  width: 303px;
  height: 21px;
  line-height: 21px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.resourceList-type {
  width: 110px;
  height: 21px;
  border-left: 1px solid #000000;
  border-right: 1px solid #000000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.resourceList-time {
  width: 128px;
  height: 21px;
  border-right: 1px solid #000000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.resourceList-classTime {
  width: 373px;
  height: 21px;
  align-items: center;
  padding-left: 5px;
  line-height: 21px;
  box-sizing: border-box;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.resourceList-seat {
  width: 62px;
  height: 21px;
  border-left: 1px solid #000000;
  border-right: 1px solid #000000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.resourceList-score {
  width: 62px;
  height: 21px;
  padding-left: 12px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
}

// 删除课程弹窗
.pop-deleteResources {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 101;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}

.deleteResources {
  position: relative;
  width: 761px;
  height: 300px;
  background: #ffffff;
  border-radius: 20px;
}

.btnClose {
  position: absolute;
  top: 24px;
  right: 24px;
}

.deleteResourcesTxt {
  position: absolute;
  width: 550px;
  height: 83px;
  font-size: 30px;

  font-weight: 400;
  color: #000000;
  text-align: center;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.btnAffirm {
  position: absolute;
  width: 200px;
  height: 50px;
  background: #349afe;
  border-radius: 10px;
  font-size: 28px;

  font-weight: 400;
  color: #ffffff;
  line-height: 50px;
  text-align: center;
  top: 217px;
  left: 50%;
  transform: translateX(-50%);
}

.addTestPaper-title {
  font-size: 26px;

  font-weight: 400;
  color: #349afe;
  text-align: center;
  margin-top: 31px;
}

.pushButton {
  width: 180px;
  height: 50px;
  background: #349afe;
  border-radius: 10px;
  font-size: 26px;

  font-weight: 400;
  color: #ffffff;
  line-height: 50px;
  text-align: center;
}

.searchIcon {
  width: 25px;
  height: 25px;
}
</style>
